<template>
<section>
  <!-- <b-breadcrumb
            align="is-left"
        >
            <b-breadcrumb-item tag='router-link' to="/">Home</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/documentation">Docs</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link' to="/documentation/breadcrumb" active>Breadcrumb</b-breadcrumb-item>
        </b-breadcrumb> -->
    <div class="wide-page">
        <Breadcrumb 
            :levelTwoText = "'Styles'"
        />
        <Heading 
        :preheading="'Find Bike Travel Blogs By'"
            :heading = "'Style and Terrain'"
            :level="1"
        />
        <div class="spacer" style="height:50px"></div>

                <div class="columns is-vcentered">
                    
                    <div class="column thumbnail">
                        <router-link to="/style/touring">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_touring2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Touring</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/bikepacking">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_bikepacking2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Bikepacking</h3>
                        </figure>
                        </router-link>
                    </div>
                    <!-- <div class="column thumbnail">
                        <router-link to="/style/racing/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_racing.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Racing</h3>
                        </figure>
                        </router-link>
                    </div> -->
                    
                </div>

                <div class="columns is-vcentered">
                    
                    <!-- <div class="column thumbnail">
                        <router-link to="/style/touring/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_touring.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Touring</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/bikepacking/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_bikepacking.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Bikepacking</h3>
                        </figure>
                        </router-link>
                    </div> -->
                    <div class="column thumbnail">
                        <router-link to="/style/racing">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_racing.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Racing</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/short">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_short2.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Short Trip</h3>
                        </figure>
                        </router-link>
                    </div>
                    
                </div>

                

                <div class="columns is-vcentered">

                    <div class="column thumbnail">
                        <router-link to="/style/pavement">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_road.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Road</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/gravel">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_gravel2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Gravel</h3>
                        </figure>
                        </router-link>
                    </div>
                </div>
                <div class="columns is-vcentered">
                    <div class="column thumbnail">
                        <router-link to="/style/singletrack">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_singletrack2.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Singletrack</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/bike%20paths">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_bikepath.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Bike Path</h3>
                        </figure>
                        </router-link>
                    </div>
                
            </div>

            <div class="columns is-vcentered">

                    <div class="column thumbnail">
                        <router-link to="/style/mountains">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_mountains.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Mountains</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/desert">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_desert3.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Desert</h3>
                        </figure>
                        </router-link>
                    </div>
                </div>
                <div class="columns is-vcentered">
                    <div class="column thumbnail">
                        <router-link to="/style/ocean">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_ocean.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Ocean</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/cities">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_cities.jpg">
                            <!-- <img src="https://bulma.io/images/placeholders/256x256.png"> -->
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Cities</h3>
                        </figure>
                        </router-link>
                    </div>
                    
                
            </div>

<!-- 
            <div class="columns is-vcentered">

                    <div class="column thumbnail">
                        <router-link to="/style/mountains/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_mountains.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Mountains</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/desert/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_desert.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Desert</h3>
                        </figure>
                        </router-link>
                    </div>
                    <div class="column thumbnail">
                        <router-link to="/style/ocean/">
                        <figure class="image is-16by9">
                            <img src="https://bikesleepbike.com/thumb_ocean.jpg">
                            <h3 class="overlay-text is-size-3 is-size-3-mobile">Ocean</h3>
                        </figure>
                        </router-link>
                    </div>
                    
                
            </div> -->


        <div class="spacer" style="height:100px"></div>
    </div>
  </section>
</template>

<script>
import Heading from '@/components/Heading';
import Breadcrumb from '@/components/Breadcrumb';
export default {
  name: 'Styles',
//   props: ['levelTwoText', 'levelTwoLink', 'levelThreeText'],
  components: {Heading, Breadcrumb},
  data () {
    return {
    //   link: "test"
    }
  },
  methods: {
   
  },
   metaInfo() {
        var title =  "Bike Travel Styles";
        var description = "Do you like gravel, pavement, singletrack, mountains, desert...? Find bike travel inspiration and trip journals tailored to your cycling interests.";
        return {
            title: title,
            titleTemplate: this.$titleTemplate,
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
            // title: 'Browse | Bike Sleep Bike',
            // description: "Find bike travel blogs"
            
        }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .wide-page {
      max-width:1000px;
      margin-left: auto;
      margin-right: auto;
      padding:20px;
  }
  .thumbnail {
        /* padding: 40px; */
    }
    .thumbnail .image {
        background-color:black;
        
    }
    .thumbnail img {
        opacity:0.8;
    }
    .thumbnail img:hover {
        opacity:0.7;
    }
    .thumbnail a {
        color:white;
    }
  .overlay-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

    }
</style>


// WEBPACK FOOTER //
// src/components/Styles.vue